import { GET_DATA, SET_DATA } from './types'

export const getTextBySlugAction = (props: any) => ({
  type: GET_DATA,
  payload: props
})

export const setTextsDataAction = (props: any) => ({
  type: SET_DATA,
  payload: props
})

export const clearTextsAction = () => ({
  type: SET_DATA,
  payload: { data: {}, interSection: null }
})
